

$(document).ready(function () { 
  $('#savedetails').prop('disabled', true);
  $('#heating_btu').html(`0 Btu`);
  $('#cooling_btu').html(`0 Btu`);
  const categoryByBtu = {
    '6000' : '/collections/6-000-btu-systems',
    '7000' : '/collections/7-000-btu-systems',
    '9000' : '/collections/9-000-btu-systems',
    '12000' : '/collections/12-000-btu-systems',
    '15000' : '/collections/15-000-btu-systems',
    '18000' : '/collections/18-000-btu-systems',
    '24000' : '/collections/24-000-btu-systems',
    '30000' : '/collections/30-000-btu-systems',
    '36000' : '/collections/36-000-btu-systems',
    '42000' : '/collections/42-000-btu-related-systems',
    '48000' : '/collections/48-000-btu-related-systems',
    '60000' : '/collections/60-000-btu-related-systems'
  }
  
  let calcuateTotalFunc = function() {
    let totalCalcuatedBTU = 0;
    let totalRecommendedBTU = 0;
    let totalCalcuations = 0;
    $(document).find('[data-rcbtu]').each((index, ele) => {
      totalCalcuations++;
      totalCalcuatedBTU += parseInt($(ele).data('rcbtu'));
    });
    
    if(totalCalcuatedBTU <= 6100){
      totalRecommendedBTU = 6000;
    }
    else if(totalCalcuatedBTU <= 7100){
      totalRecommendedBTU = 7000;
    }
    else if(totalCalcuatedBTU <= 9100){
      totalRecommendedBTU = 9000;
    }
    else if(totalCalcuatedBTU <= 12100){
      totalRecommendedBTU = 12000;
    }
    else if(totalCalcuatedBTU <= 15100){
      totalRecommendedBTU = 15000;
    }
    else if(totalCalcuatedBTU <= 18100){
      totalRecommendedBTU = 18000;
    }
    else if(totalCalcuatedBTU <= 20100){
      totalRecommendedBTU = 20000;
    }
    else if(totalCalcuatedBTU <= 24100){
      totalRecommendedBTU = 24000;
    }
    else if(totalCalcuatedBTU <= 30100){
      totalRecommendedBTU = 30000;
    } 
    else if(totalCalcuatedBTU <= 36100){
      totalRecommendedBTU = 36000;
    }
    else if(totalCalcuatedBTU <= 42100){
      totalRecommendedBTU = 42000;
    }
    else if(totalCalcuatedBTU <= 48100){
      totalRecommendedBTU = 48000;
    }
    else if(totalCalcuatedBTU <= 60100){
      totalRecommendedBTU = 60000;
    }
    else {
      totalRecommendedBTU = -1;
    }
    if (totalRecommendedBTU != -1) {
      
      if (totalCalcuatedBTU == 0) {
          $('#totaldrmdetails').html(``); 
      } else {
         $('#totaldrmdetails').html(`<p>TOTAL CALCULATED BTU FOR (${totalCalcuations}) ROOM(S): ${addCommas(totalCalcuatedBTU)} BTU</p><p><b>RECOMMENDED OUTDOOR UNIT: <a href="${categoryByBtu[totalRecommendedBTU]}">${addCommas(totalRecommendedBTU)} BTU</a></b></p>`);  
      }
    } else {
      $('#totaldrmdetails').html(`<p>TOTAL CALCULATED BTU FOR (${totalCalcuations}) ROOM(S): ${addCommas(totalCalcuatedBTU)} BTU</p><p>Please Call <a href="tel:8663990206">(899) 399-0206</a> for Design Support</p>`);
    }
  };

  function removeDiv(event, str){
    event.preventDefault();
    $('.rmv' + str).remove();
    var savedroom   = parseInt($('#savedroom').val());
    savedroom = savedroom - 1;
    $('#savedroom').val(savedroom);
    if(savedroom <= 0){
      $('.svd').hide();
    }
    calcuateTotalFunc();
  }
  function addCommas(x) {
    var parts = x.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  }
  function btucalculate(){
    var rwidth   = parseInt($('#rwidth').val());
    var rlength  = parseInt($('#rlength').val());
    var windows  = parseInt($('#no_windows').val());
    var people   = parseInt($('#people').val());
    var rtype    = parseFloat($('#rtype').val());
    var ctype    = parseFloat($('#ctype').val());
      
    var rsize = (rwidth * rlength);
      
    //alert(rsize);
      
    var Cooling_BTU = '';
    var Heating_BTU = '';
      
    if ((rsize >= 100) && (rsize < 300)){
      Cooling_BTU = 30;
      Heating_BTU = 50;
    }
    else if ((rsize >= 300) && (rsize < 500)){
      Cooling_BTU = 25;
      Heating_BTU = 45;
    }
    else if ((rsize >= 500) && (rsize < 800)){
      Cooling_BTU = 22;
      Heating_BTU = 42;
    }
    else if ((rsize >= 800) && (rsize < 1000)){
      Cooling_BTU = 20;
      Heating_BTU = 40;
    }
    else if ((rsize >= 1000)){
      Cooling_BTU = 18;
      Heating_BTU = 38;
    }
      
    var Cooling = parseInt((((rsize * Cooling_BTU)+(windows * 570)+(people * 300)) * rtype) * ctype);
    var Heating = parseInt((((rsize * Heating_BTU)+(windows * 570)-(people * 300)) * rtype) * ctype);
    
    var recommended_unit = 0;
    var categoryURL = '';
    
    if(Cooling <= 6100){
      recommended_unit = 6000;
    }
    else if(Cooling <= 7100){
      recommended_unit = 7000;
    }
    else if(Cooling <= 9100){
      recommended_unit = 9000;
    }
    else if(Cooling <= 12500){
      recommended_unit = 12000;
    }
    else if(Cooling <= 15500){
      recommended_unit = 15000;
    }
    else if(Cooling <= 18500){
      recommended_unit = 18000;
    }
    else if(Cooling <= 24500){
      recommended_unit = 24000;
    }
    else if(Cooling <= 30500){
      recommended_unit = 30000;
    }
    else if(Cooling <= 36500){
      recommended_unit = 36000;
    }
    else if(Cooling <= 42500){
      recommended_unit = 42000;
    }
    else if(Cooling <= 48500){
      recommended_unit = 48000;
    }
    else if(Cooling <= 60500){
      recommended_unit = 60000;
    }
    else if(Cooling > 65000){
      recommended_unit = 0;
    }

    if (recommended_unit != 0) {
      categoryURL = categoryByBtu[recommended_unit];
    } else {
      categoryURL = '';
    }

// If cooling is more than 65,000 - dispaly Call 866 for Design Support

    if (recommended_unit == 0) {
      $('.recomd_zero').show();
      $('.recomd').hide();
      $('#savedetails').prop('disabled', true);
    } else {
      $('.recomd_zero').hide();
      $('.recomd').show();
      $('#savedetails').prop('disabled', false);
    }
    
    recommended_unit = addCommas(recommended_unit);
    Heating = addCommas(Heating);
    Cooling = addCommas(Cooling);
    
    $('#heating_btu').html(`${Heating} Btu`);
    $('#cooling_btu').html(`${Cooling} Btu`);
    $('#recunit').html(recommended_unit);
    console.log(categoryURL);
    $('#recunit_link').attr('href', categoryURL);
  }
  
  $('.digitsonly input').keyup(function(e)
  {
    if (/\D/g.test(this.value))
    {
      // Filter non-digits from input value.
      this.value = this.value.replace(/\D/g, '');
    }
  });

  $( "#BTUCalculator" ).submit(function( event ) {
    event.preventDefault();
    btucalculate();
  });

  $("#BTUCalculator").on('reset', function(event) {
    $('#heating_btu').html('0');
    $('#cooling_btu').html('0');
    $('#recunit').html('0');
    $('.recomd_zero').hide();
    $('.recomd').show();
  });

  $('#calculatedetails').on('click', function(event) {
    btucalculate();
  });
  
  // $(".ipt").keyup(function(){
  //   var d = true;
  //   $(".ipt").each(function(){
  //     if($(this).val()){
  //       d = true;
  //     }
  //     else{
  //       d = false;
  //     }
  //   });
  //   if(d){
  //     btucalculate();
  //     // $('#savedetails').prop("disabled", false);
  //   }
  //   else{
  //     $('#heating_btu').html('0');
  //     $('#cooling_btu').html('0');
  //     $('#recunit').html('0');
  //     // $('#savedetails').prop("disabled", true);
  //   }
  // });
  // $(".ipt").change(function(){
  //   var d = true;
  //   $(".ipt").each(function(){
  //     if($(this).val()){
  //       d = true;
  //     }
  //     else{
  //       d = false;
  //     }
  //   });
  //   if(d){
  //     btucalculate();
  //     // $('#savedetails').prop("disabled", false);
  //   }
  //   else{
  //     $('#heating_btu').html('0');
  //     $('#cooling_btu').html('0');
  //     $('#recunit').html('0');
  //     // $('#savedetails').prop("disabled", true);
  //   }
  // });
  $('#savedetails').click(function(){
    var savedroom   = parseInt($('#savedroom').val());
    savedroom = savedroom + 1;
    $('#savedroom').val(savedroom);
    var rname = $('#rname').val();
    var rwidth   = parseInt($('#rwidth').val());
    var rlength  = parseInt($('#rlength').val());
    var windows  = parseInt($('#no_windows').val());
    var people   = parseInt($('#people').val());
    var rtype    = parseFloat($('#rtype').val());
    var ctype    = parseFloat($('#ctype').val());
    var rtype2   = $('#rtype').find('option:selected').attr('data-attr');
    var ctype2   = $('#ctype').find('option:selected').attr('data-attr');
    var rsize    = (rwidth * rlength);
    var coolingbtu = $('#cooling_btu').html();
    var heatingbtu = $('#heating_btu').html();
    var recmdunit = $('#recunit').html();
    var recunitLink = $('#recunit_link').attr('href');
    var content = '<div class="savedroom rmv'+ savedroom +'"><h2>' + rname + '<a class="trashicon" href="#" data-savedroom="' + savedroom + '"></a></h2><p>Room size: ' + rwidth + ' x ' + rlength + ' = ' + rsize + 'sq</p><p>Windows: '+ windows +'</p><p>Amount of People: '+ people +'</p><p>Room Type: '+ rtype2 +'</p><p>Insulation Type: '+ ctype2 +'</p><p>Btu Cooling: '+ coolingbtu +`</p>` + `<p>Btu Heating: ${heatingbtu}</p>` + `<p class="rcd" data-rcbtu="${recmdunit.replaceAll(',', '')}">Recommended BTU: <a href="${recunitLink}">`+ recmdunit +' btu</a></p></div>';
    $('#savedrmdetails').append(content);
    $('.svd').show();

    //Calculate total BTU
    calcuateTotalFunc();
  });
  $( ".noticeicon" ).mouseover(function() {
    $(this).closest('div').find('.tooltps').show();
  });
  $( ".noticeicon" ).mouseout(function() {
    $(this).closest('div').find('.tooltps').hide();
  });

  $(document).on('click', '.trashicon', function(e) {
    removeDiv(e, $(this).data('savedroom'));
  });
  
  $(".faqhead h3").click(function(){
   var target = $(this).attr('data-target');
   if (!$(target).hasClass("on")) {
    $(".faqitem").removeClass("on");
    $(target).addClass("on");
    $('html, body').animate({
        scrollTop: $(target).offset().top
    }, 1000);
   }
  })
});